import { DependencyList, EffectCallback, useEffect } from 'react';
import { useIsFirstRender } from './useIsFirstRender';

/**
 * A modified version of `useEffect` that skips the initial run.
 * It behaves normally after the initial render and runs
 * whenever one or more of its dependencies changes.
 */
export const useUpdateEffect = (
  callback: EffectCallback,
  deps?: DependencyList,
  useUseEffectHook: typeof useEffect = useEffect,
): void => {
  const isFirst = useIsFirstRender();

  useUseEffectHook(() => {
    if (!isFirst) {
      return callback();
    }
    // NOTE: In this rare case, ignoring exhaustive deps is correct.
    // This effect should _only_ run in response to one of its provided
    // deps changing. We also don't need to worry about the `callback`
    // reference changing because `useEffect` expects a stable
    // `EffectCallback` as its first parameter.
  }, deps);
};
